/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { Link, LinkProps } from "react-router-dom";
import { styled } from "@mui/material";
import { nameof } from "../../Utils/AnyUtil";
import ignoreWithTooltipProps from "../HOC/ignoreWithTooltipProps";

export interface AppLinkProps extends LinkProps {
    noWrap?: boolean;
}

const AppLink = styled(Link, {
    shouldForwardProp: prop => prop !== nameof<AppLinkProps>("noWrap")
})<AppLinkProps>(({ noWrap, theme }) => ([
    {
        color: theme.palette.secondary.main,
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline",
        },
    },
    noWrap && {
        whiteSpace: "nowrap",
    },
]));

export default ignoreWithTooltipProps(AppLink);